// User roles constants
export const ROLES = {
  ADMINISTRATOR: 'ADMINISTRATOR',
  CHIEF_LOAN_OFFICER: 'CHIEF_LOAN_OFFICER',
  LOAN_OFFICER: 'LOAN_OFFICER',
  COLLECTIONS_OFFICER: 'COLLECTIONS_OFFICER',
  ACCOUNTANT: 'ACCOUNTANT',
  OPERATOR: 'OPERATOR',
  STATISTICS: 'STATISTICS',
  VIEWER: 'VIEWER',
};

// Array of all roles
export const ROLE_LIST = [
  ROLES.ADMINISTRATOR,
  ROLES.CHIEF_LOAN_OFFICER,
  ROLES.LOAN_OFFICER,
  ROLES.COLLECTIONS_OFFICER,
  ROLES.ACCOUNTANT,
  ROLES.OPERATOR,
  ROLES.STATISTICS,
  ROLES.VIEWER,
];

export default ROLES;
